export class LoaderData {
  title?: string = '';
  loaderType?: LoaderType = 'spinner';
}

export type LoaderType = 'spinner' | 'progressBar';
